import React, { memo } from 'react';
import { createHOC } from '@redlink/core';
import { ModalContainer } from '@redlink/components/atoms';

export const withPopUp = createHOC(
  (WrappedComponent) =>
    memo(({ isVisible, onDismiss, ...rest }) => {
      return (
        <ModalContainer
          visible={isVisible}
          onRequestClose={onDismiss}
          style={{ alignItems: 'center', justifyContent: 'center' }}
        >
          <WrappedComponent onDismiss={onDismiss} {...rest} />
        </ModalContainer>
      );
    }),
  'withPopUp'
);
